import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useMasterAccountheadsQuery } from "../../../services/accountHeadApi";
import { signInUser } from "../../Utility/Auth";

const SelectAccountHead = ({ handleOnchange }) => {
  const auth = signInUser();
  const aamarId = auth?.aamarId;
  const { data, error, isLoading, isFetching, isSuccess } =
    useMasterAccountheadsQuery({ aamarId }, { skip: !aamarId });
  let [accountHead, setAccountHead] = useState([]);

  useEffect(() => {
    let accountHeads = [
      { option: "no-accountHeads", label: "Select accountHeads Category" },
    ];
    if (isSuccess && data && data.length > 0) {
      data.forEach((item) => {
        accountHeads.push({
          option: item?._id,
          label: `${item?.name} - ( ${item?.code} )`,
          code: item?.code,
        });
      });
      setAccountHead(accountHeads);
    } else {
      setAccountHead(accountHeads);
    }
  }, [data, error, isSuccess]);

  // console.log(accountHead);
  // const OnChangeSelect = (value) => {
  //   console.log(value);
  // };

  // useEffect(() => {
  //   let vendors = [];
  //   if (accountHead.length > 0) {
  //     accountHead.map((vendor) => {
  //       vendors = [
  //         ...vendors,
  //         {
  //           option: vendor._id,
  //           label: vendor.name,
  //         },
  //       ];
  //     });
  //     setVendor(vendors);
  //   }
  // }, [accountHead]);
  // console.log(vendor)

  // console.log(vendor.filter((sel) => sel?.option?.toString() === accountHead_code?.toString()))

  return (
    <Fragment>
      <Select
        className="select"
        classNamePrefix="Select AccountHead"
        defaultValue={accountHead[0]}
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        value={accountHead[accountHead.indexOf(accountHead)]}
        isSearchable={true}
        name="accountHead_code"
        onChange={handleOnchange}
        options={accountHead}
      />

      <div
        style={{
          color: "hsl(0, 0%, 40%)",
          display: "inline-block",
          fontSize: 12,
          fontStyle: "italic",
          marginTop: "1em",
        }}
      ></div>
    </Fragment>
  );
};

export default SelectAccountHead;
